/* eslint-disable @typescript-eslint/indent */
import { SaveOutlined, UserOutlined } from '@ant-design/icons'
import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  Row,
  Typography,
  message,
} from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { WaitOverlay } from '~/Components'
import {
  OrganizationsService,
  UpdateInfoParams,
} from '~/Services/OrganizationService'
import { useAppDispatch, useAppSelector } from '~/Store/hooks'
import { OrganizationActions } from '~/Store/Organization'
import { WaitOverlayActions } from '~/Store/Overlays'
import { UserSelectors, UserActions } from '~/Store/User'
import styles from './Info.module.less'

const { Title } = Typography

const waitOverlayName = 'fetchingOrgInfo'

export const EditForm = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const organization = useAppSelector(UserSelectors.getDefaultOrganization)
  const currentUser = useAppSelector(UserSelectors.getCurrentUser)

  const {
    companyName,
    billingAddress,
    billingAddress2,
    billingCity,
    billingState,
    billingZip,
    guid,
  } = organization || {}
  const { email } = currentUser || {}

  const onFinish = async (value: UpdateInfoParams) => {
    if (!organization) {
      message.error(t('organizationNotFound'))
      return
    }

    try {
      dispatch(
        WaitOverlayActions.setVisible({ name: waitOverlayName, value: true }),
      )
      const params: Partial<UpdateInfoParams> = {
        companyName: value.companyName,
        billingAddress: value.billingAddress,
        billingAddress2: value.billingAddress2,
        billingCity: value.billingCity,
        billingState: value.billingState,
        billingZip: value.billingZip,
        guid,
      }
      await OrganizationsService.Put.updateOrganizationInfo(guid, params)

      // Thông báo thành công
      message.success(t('updateOrgSuccess'))

      // Update User store (defaultOrganization) - ĐÚNG STORE RỒI!
      dispatch(
        UserActions.setDefaultOrganization({
          ...organization,
          companyName: value.companyName,
          billingAddress: value.billingAddress,
          billingAddress2: value.billingAddress2,
          billingCity: value.billingCity,
          billingState: value.billingState,
          billingZip: value.billingZip,
        }),
      )

      // Tắt edit mode
      dispatch(OrganizationActions.toggleIsEditMode())
    } catch (err) {
      console.log(err)
      message.error(t('updateFailed'))
    } finally {
      dispatch(
        WaitOverlayActions.setVisible({ name: waitOverlayName, value: false }),
      )
    }
  }

  const cancelChanges = () => {
    dispatch(OrganizationActions.toggleIsEditMode())
  }

  return (
    <WaitOverlay
      name={waitOverlayName}
      size="large"
      wrapperClassName={styles.FullOverlay}
    >
      <div>
        <Form
          layout="vertical"
          initialValues={{
            companyName,
            email,
            role: t('jobTitle'),
            billingAddress,
            billingAddress2,
            billingCity,
            billingState,
            billingZip,
          }}
          onFinish={onFinish}
        >
          <Row align="stretch" className={styles.editRow}>
            <Title style={{ flex: 1 }} level={4}>
              {t('organizationInformation')}
            </Title>
            <div className={styles.CancelButton}>
              <Button onClick={cancelChanges} danger>
                {t('cancel')}
              </Button>
            </div>
            <Button className={styles.editOrg} htmlType="submit" type="primary">
              {t('saveChanges')}
              <SaveOutlined />
            </Button>
          </Row>
          <div className={styles.organizationInfo}>
            <Row className={styles.editRow}>
              <Avatar
                shape="square"
                size="large"
                icon={<UserOutlined />}
                className={styles.orgLogo}
              />
              <div className={styles.editOrg}>
                <div className={styles.editWord}>{t('changeAvatar')}</div>
              </div>
            </Row>
            <Form.Item label={t('organizationName')} name="companyName">
              <Input width="100%" />
            </Form.Item>
            <Form.Item label={t('email')} name="email">
              <Input width="100%" disabled />
            </Form.Item>
            <Form.Item label={t('officeAddress')} name="billingAddress">
              <Input width="100%" />
            </Form.Item>
            <Form.Item label={t('billingAddress')} name="billingAddress2">
              <Input width="100%" />
            </Form.Item>
            <Row className={styles.editRow} gutter={[16, 0]}>
              <Col span={8}>
                <Form.Item label={t('city')} name="billingCity">
                  <Input width="100%" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={t('state')} name="billingState">
                  <Input width="100%" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={t('zip')} name="billingZip">
                  <Input width="100%" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </WaitOverlay>
  )
}